.tools { display: flex; align-items: center; gap: 10px; }
.hint { font-size: 12px; color: var(--lb); }
.grid { display: grid; grid-template-columns: minmax(0, 1fr) 340px; gap: 14px; align-items: start; }
.grid > section { overflow: clip; }
.row { display: grid; padding: 0 18px; height: 49px; align-items: center; border-bottom: 1px solid var(--line); }
.sale { grid-template-columns: minmax(0, 1.6fr) 70px 100px 100px 80px 120px 80px 60px; }
.other { grid-template-columns: minmax(0, 2fr) 80px 120px 120px 90px; }
.head { height: 40px; font-size: 12px; color: var(--lb); }
.r { text-align: right; }
.row > b { font-weight: var(--fw-label); }
.name > b { font-weight: var(--fw-label); }
.name > div { font-size: 12px; color: var(--lb); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pct { display: flex; align-items: center; gap: 6px; justify-content: flex-end; }
.bar { width: 60px; height: 6px; border-radius: 3px; background: var(--line); overflow: hidden; }
.bar > i { display: block; height: 100%; }
.tier { padding: 2px 8px; border-radius: 6px; background: var(--sub); font-size: 12px; font-weight: var(--fw-label); }
.foot { height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0 18px; color: var(--lb); }
.side { display: flex; flex-direction: column; gap: 12px; }
.box { padding: 14px 16px; }
.box h2 { margin: 0 0 6px; font-size: 15px; font-weight: var(--fw-title); }
.sus { display: flex; flex-direction: column; gap: 4px; padding: 9px 0; border-top: 1px solid var(--line); }
.sus > div:first-child { display: flex; justify-content: space-between; align-items: center; }
.sus a { color: var(--link); font-weight: var(--fw-label); text-decoration: none; }
.susk { font-size: 12px; color: var(--tx2); }
.why { padding: 2px 8px; border-radius: 999px; font-size: 11px; font-weight: var(--fw-label); }
.warn { background: var(--warn-bg); color: var(--warn); }
.pri { background: var(--pri-bg); color: var(--link); }
.err { background: var(--err-bg); color: var(--err); }
.vat { display: flex; justify-content: space-between; height: 30px; align-items: center; border-top: 1px solid var(--line); }
.vat:first-of-type { border-top: 0; }
.vat span { color: var(--tx2); }
.vat b { font-weight: var(--fw-label); }
.help { height: 40px; border: 1px solid var(--bd); border-radius: 12px; background: var(--card); color: var(--tx); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
.ok { color: var(--ok); }
